import React, { Component } from 'react';
import { ReactComponent as JS } from '../components/icons/js.svg';
import { ReactComponent as TS } from '../components/icons/ts.svg';
import { ReactComponent as HTML } from '../components/icons/html.svg';
import { ReactComponent as CSS } from '../components/icons/css.svg';
import { ReactComponent as POSTGRES } from '../components/icons/postgres.svg';
import { ReactComponent as PYTHON } from '../components/icons/python.svg';
import { ReactComponent as JAVA } from '../components/icons/java.svg';
import { ReactComponent as C_LANG } from '../components/icons/c.svg';
import { ReactComponent as NODEJS } from '../components/icons/nodejs.svg';
import { ReactComponent as EXPRESS } from '../components/icons/express.svg';
import { ReactComponent as MONGODB } from '../components/icons/mongodb.svg';
import { ReactComponent as REACT } from '../components/icons/react.svg';
import { ReactComponent as ELECTRON } from '../components/icons/electron.svg';
import { ReactComponent as GITHUB } from '../components/icons/github.svg';
import { ReactComponent as EMAIL } from '../components/icons/email.svg';
import { ReactComponent as DISCORD } from '../components/icons/discord.svg';
import { ReactComponent as LINKEDIN } from '../components/icons/linkedin.svg';
import { ReactComponent as NEXT } from '../components/icons/next.svg';
import { ReactComponent as TAILWIND } from '../components/icons/tailwindcss.svg';
import { ReactComponent as SOLIDITY } from '../components/icons/solidity.svg';
import { ReactComponent as ETHEREUM } from '../components/icons/ethereum.svg';
import { ReactComponent as GO } from '../components/icons/go.svg';
import { ReactComponent as HASKELL } from '../components/icons/haskell.svg';
import { ReactComponent as GRAPHQL } from '../components/icons/graphql.svg';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default class Home extends Component {
	render() {
		return (
			<motion.div initial="initial" animate="in" exit="out" variants={this.props.pageVariants} transition={this.props.pageTransition}>
				<div className="main-content">
					<div className="left-column" style={{ margin: 'auto' }}>
						<h1 id="title-text">{this.props.helloText}</h1>
						<p id="content-text">{this.props.contText}</p>
						<a data-umami-event="linkedin-button" href="https://linkedin.com/in/nadhirxz" target="_blank" id="github">
							<LINKEDIN className="svg-link" width={style.width} height={style.height} title="LinkedIn" />
						</a>
						<a data-umami-event="github-button" href="https://github.com/nadhirxz" target="_blank" id="github">
							<GITHUB className="svg-link" width={style.width} height={style.height} title="Github" />
						</a>
						<a data-umami-event="email-button" href="mailto:nadhirxz@gmail.com" target="_blank" id="email">
							<EMAIL className="svg-link" width={style.width} height={style.height} title="Email" />
						</a>
						<a data-umami-event="discord-button" href="https://discord.com/users/626920219759083528" target="_blank" id="discord">
							<DISCORD className="svg-link" width={style.width} height={style.height} title="Discord" />
						</a>
					</div>
					<div className="right-column">
						<h4 id="languages">{this.props.langText}</h4>
						<div className="container">
							<JS style={style} className="icon" title="JavaScript" />
							<TS style={style} className="icon" title="TypeScript" />
							<HTML style={style} className="icon" title="HTML5" />
							<CSS style={style} className="icon" title="CSS3" />
							<PYTHON style={style} className="icon" title="Python" />
							<JAVA style={style} className="icon" title="Java" />
							<C_LANG style={style} className="icon" title="C" />
							<GO style={style} className="icon" title="Go" />
							<HASKELL style={style} className="icon" title="Haskell" />
							<SOLIDITY style={style} className="icon" title="Solidity" />
						</div>
						<h4 id="tools">{this.props.toolsText}</h4>
						<div className="container">
							<NODEJS style={style} className="icon" title="Node.js" />
							<EXPRESS style={style} className="icon" title="Express.js" />
							<REACT style={style} className="icon" title="React" />
							<NEXT style={style} className="icon" title="Next" />
							<GRAPHQL style={style} className="icon" title="GraphQL" />
							<TAILWIND style={style} className="icon" title="TailwindCSS" />
							<MONGODB style={style} className="icon" title="MongoDB" />
							<POSTGRES style={style} className="icon" title="PostgreSQL" />
							<ELECTRON style={style} className="icon" title="Electron" />
							<ETHEREUM style={style} className="icon" title="Ethereum" />
						</div>

						<div className="buttons-container">
							<Link id="skills-link" to="/skills">
								<button className="btn" style={{ width: '40%', marginInline: 8 }}>
									Skills
								</button>
							</Link>

							<Link id="projects-link" to="/projects">
								<button className="btn" style={{ width: '40%', marginInline: 8 }}>
									Projects
								</button>
							</Link>

							<a data-umami-event="cv-button" id="cv-link" href="cv-nadhir-ferdji.pdf" target="_blank">
								<button className="btn" style={{ width: '40%', marginTop: 15 }}>
									Resume
								</button>
							</a>
						</div>
					</div>
				</div>
			</motion.div>
		);
	}
}
const style = {
	width: '50px',
	height: '50px',
	transition: 'opacity 2s',
};
